import ApiService from "@/services/api.service";

const route = 'download-bills';

const downloadBills = {
    download(_data) {
        return new Promise((resolve, reject) => {
            ApiService.postDownload(`${route}`, _data).then(response => {
                resolve({headers: response.headers, data: response.data});
            }, (error) => { 
                reject(error);
            });
        });
    }
};

export default downloadBills;